//# sourceMappingURL=levenshtein.mjs.map
/// <reference types="./levenshtein.d.mts" />
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import { toList, Empty as $Empty, prepend as listPrepend } from "../gleam.mjs";

function levenshtein_row(
  loop$b,
  loop$previous_row,
  loop$current_row_reversed,
  loop$ac,
  loop$left
) {
  while (true) {
    let b = loop$b;
    let previous_row = loop$previous_row;
    let current_row_reversed = loop$current_row_reversed;
    let ac = loop$ac;
    let left = loop$left;
    if (b instanceof $Empty) {
      return $list.reverse(current_row_reversed);
    } else if (previous_row instanceof $Empty) {
      return $list.reverse(current_row_reversed);
    } else {
      let $ = previous_row.tail;
      if ($ instanceof $Empty) {
        return $list.reverse(current_row_reversed);
      } else {
        let bc = b.head;
        let brest = b.tail;
        let prev_left = previous_row.head;
        let prev_up = $.head;
        let prev_rest = $.tail;
        let insertion = prev_left + 1;
        let deletion = prev_up + 1;
        let substitution = prev_left + (() => {
          let $1 = ac === bc;
          if ($1) {
            return 0;
          } else {
            return 1;
          }
        })();
        let value = $int.min(insertion, $int.min(deletion, substitution));
        loop$b = brest;
        loop$previous_row = listPrepend(prev_up, prev_rest);
        loop$current_row_reversed = listPrepend(value, current_row_reversed);
        loop$ac = ac;
        loop$left = left + 1;
      }
    }
  }
}

function levenshtein_rows(loop$a, loop$b, loop$previous_row) {
  while (true) {
    let a = loop$a;
    let b = loop$b;
    let previous_row = loop$previous_row;
    if (a instanceof $Empty) {
      let _pipe = $list.last(previous_row);
      return $result.unwrap(_pipe, 0);
    } else {
      let ac = a.head;
      let arest = a.tail;
      let current_row = levenshtein_row(b, previous_row, toList([1]), ac, 0);
      loop$a = arest;
      loop$b = b;
      loop$previous_row = current_row;
    }
  }
}

function build_row(current, stop) {
  let $ = current > stop;
  if ($) {
    return toList([]);
  } else {
    return listPrepend(current, build_row(current + 1, stop));
  }
}

export function levenshtein(a, b) {
  let a_chars = $string.to_graphemes(a);
  let b_chars = $string.to_graphemes(b);
  let previous_row = build_row(0, $string.length(b));
  return levenshtein_rows(a_chars, b_chars, previous_row);
}
